import OnboardingLinkPage from "./v2/pages/onboarding/onboarding-link-page.tsx";
import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./utils/ScrollToTop";
import Login from "./v2/pages/auth/login-page/login-page.tsx";
import ForgotPassword from "./v2/pages/auth/forgot-password-page/forgot-password-page.tsx";
import ResetPassword from "./v2/pages/auth/reset-password-page/reset-password-page.tsx";
import OnboardPostJoinPage from "./v2/pages/onboard-post-join/onboard-post-join-page.tsx";
import UsPostJoinPage from "./v2/pages/onboarding/us/post-join/us-post-join-page.tsx";
import { getAuthToken } from "./utils/Storage";
import { ToastContainer } from "react-toastify";
import { Toaster } from "sonner";
// import Home from "./Pages/Home";
import Home from "./v2/components/layout/home.tsx";
import MaintenancePage from "./v2/pages/maintenance-page.tsx";
import MigrationPage from "./v2/pages/migration-page.tsx";

function App() {
  const { pathname } = useLocation();
  const path = String(pathname);
  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";
  const migrationMode = process.env.REACT_APP_MIGRATION_MODE === "true";

  if (maintenanceMode) {
    return <MaintenancePage />;
  }

  if (migrationMode) {
    return <MigrationPage />;
  }

  function RequireAuth({ children, redirectTo }) {
    const hasSession = getAuthToken("accessToken") || getAuthToken("refreshToken");
    return hasSession ? <Navigate to={redirectTo} /> : children;
  }

  return (
    <>
      {path.includes("/dashboard") ? (
        <Home />
      ) : (
        <Routes>
          <Route path="*" exact element={<Navigate to="/" />} />
          <Route
            path="/"
            exact
            element={
              <RequireAuth redirectTo="/dashboard">
                <Login />
              </RequireAuth>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/onboard-post-join" element={<OnboardPostJoinPage />} />
          <Route path="/onboard-post-join/sqe" element={<OnboardPostJoinPage />} />
          <Route path="/onboarding/verify" element={<OnboardingLinkPage />} />
          <Route path="/create-employee" element={<OnboardingLinkPage />} />
          <Route path="/create-employee/sqe" element={<OnboardingLinkPage />} />
          <Route path="/create-employee/us" element={<OnboardingLinkPage />} />
          <Route path="/onboarding/us/pre-join" element={<OnboardingLinkPage />} />
          <Route path="/onboarding/consultant-india" element={<OnboardingLinkPage />} />
          <Route path="/onboarding/consultant-us" element={<OnboardingLinkPage />} />
          <Route path="/create-employee/consultant/india" element={<OnboardingLinkPage />} />
          <Route path="/create-employee/consultant/us" element={<OnboardingLinkPage />} />
          <Route path="/create-employee/consultant/vendor" element={<OnboardingLinkPage />} />
          <Route path="/HRMIS/create-agency" element={<OnboardingLinkPage />} />
          <Route path="/onboard-post-join/us" element={<UsPostJoinPage />} />
        </Routes>
      )}
      <ToastContainer />
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          success: {
            duration: 1000,
          },
          error: {
            duration: 2000,
          },
        }}
      />
      <ScrollToTop />
    </>
  );
}

export default App;
